import { IwanRequestConfig } from '../interface';

export const addTimeParam = (config: IwanRequestConfig): IwanRequestConfig => {
  const retConfig = config;
  if (config.cache === false) {
    retConfig.params = {
      ...retConfig.params,
      _iwtsp_: Date.now(),
    };
    return retConfig;
  }

  return retConfig;
};
